<!-- Floating Chat Button -->
<button (click)="toggleChat()"
  class="chat-toggle-btn">
  💬
</button>

<!-- Chat Box -->
<div class="chat-box" [class.chat-box-visible]="showChat">

  <div class="chat-header" style="display: flex; width: 100%; flex-direction: row;">
  <div style="width: 90%;"><p *ngIf="registeredUserSocketStatus?.success">welcome, {{registeredUserSocketStatus?.data?.user_data?.first_name}}</p>
    <!-- <div *ngIf="connectionStatus?.status === 'connected'" style="color:green">
      ✅ Connected (ID: {{connectionStatus?.id}})
    </div>
    
    <div *ngIf="connectionStatus?.status === 'disconnected'" style="color:red">
      ❌ Disconnected (Reason: {{connectionStatus?.reason}})
      <span (click)="reconnect()" style="cursor: pointer;">Connect</span>
    </div>
    
    <div *ngIf="connectionStatus?.status === 'reconnecting'" style="color:orange">
      🔄 Reconnecting...
    </div> -->
  </div>
  <div *ngIf="registeredUserSocketStatus?.success">   <span (click)="disconnect()" style="cursor: pointer;">X</span></div>
 
  </div>
  <!-- <input [(ngModel)]="name" placeholder="Your name" /> -->

  <!-- {{messages | json}} -->
  <div class="chat-body1" *ngIf="startChat" style="height: 12rem;
  border: 1px solid;
  overflow-x: scroll;">
    <!-- <div *ngFor="let msg of messages" class="chat-msg1">
        <div [ngClass]="(msg.sender===name) ? 'my-msg' : 'their-msg'">
            <strong>{{ msg.sender }}:</strong> {{ msg.message }}
          </div>
    </div> -->

    <div *ngFor="let msg of chatLog" style="padding-left: 3%; padding-top: 1%;">
        <strong>{{ msg.from_name }}:</strong> {{ msg.message }}
      </div>
  </div>
  <div class="chat-body1" *ngIf="startChat" style="height: 7rem;
  border: 1px solid red;
  overflow-x: scroll;">
    <!-- <div *ngFor="let msg of messages" class="chat-msg1">
        <div [ngClass]="(msg.sender===name) ? 'my-msg' : 'their-msg'">
            <strong>{{ msg.sender }}:</strong> {{ msg.message }}
          </div>
    </div> -->

    <div   style="padding-left: 3%; padding-top: 1%;">
      <ng-container *ngIf="onlineUsers.length > 1">
        <span *ngIf="recipientId==''" style="color: red; font-size: 0.7rem; display: flex;">No user selected</span>
      <span *ngFor="let user of onlineUsers" style="display: flex;"> 
      <strong *ngIf="user.userId!=userId" (click)="setRecipientId(user.userId)">{{ user.name }} <i style="font-size: 0.5rem; color: var(--primary-color);" *ngIf="user.selected">Chatting...</i></strong>
      </span> 
    </ng-container>
    <ng-container *ngIf="onlineUsers.length<2">
      <p >No one online</p>
    </ng-container>
      </div>

  </div>
  <!-- <div>
    <label>Recipient ID: <input [(ngModel)]="recipientId" /></label>
  </div> -->
  
  
  <div class="chat-input-container" *ngIf="connectionStatus?.status === 'connected' && startChat ">
    <div style="width: 80%;">
      <input style="width: 95%;" [(ngModel)]="message" [disabled]="(onlineUsers?.length ?? 0) < 2" (keydown.enter)="sendMessage()" placeholder="Type your message..." />
    </div>
    <div style="width: 20%;">
      <button (click)="sendMessage()" [disabled]="(onlineUsers?.length ?? 0) < 2" >Send</button>
    </div>
    
   
  </div>

  <div class="chat-footer" *ngIf="connectionStatus?.status === 'disconnected'">
    <div style="align-items: center;"  >
      <span style="color:red">❌ You disconnected </span>
      <span (click)="reconnect()" style="cursor: pointer;">Connect again</span>
    </div>
  </div>

  <div class="chat-footer" *ngIf="!startChat">
    <!-- <input [(ngModel)]="name"  placeholder="Your name" />
    <button (click)="startChartFields()">Start</button> -->
    <ng-container *ngIf="btnSubmit && !registeredUserSocketStatus?.success">
      <span style="color: red; font-size: 0.7rem; display: flex;">Invalid user details</span>
    </ng-container>
    
    <ng-container>
      <label ><input [(ngModel)]="userId" placeholder="Your Key ID" (keydown.enter)="register()" />
        <a (click)="register()" style="color: var(--primary-color);" >Verify</a>
      </label>
    </ng-container>
    
    
  </div>
</div>

<!-- <h1>Real-time Chat</h1>
<input [(ngModel)]="message" placeholder="Type a message" />
<button (click)="send()">Send</button>
<ul>
  <li *ngFor="let msg of messages">{{ msg.message }}</li>
</ul> -->
